import React, { useState } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { TemplateSFObjectStore } from '../../../../store/models/template-object.model';
import GridTemplateConfigurationController from '../grid-template-config.controller';
import { Utility } from '../../../../common/utility';
import { observer } from 'mobx-react';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string;
    updateViewSourceComponentConfig: Function;
    updateViewSource: Function;
    fieldInfo: IFieldData;
}

const GridFilterByRecordType = (props: IProps) => {
    const templateConfigCtrl: GridTemplateConfigurationController = new GridTemplateConfigurationController();
    const util: Utility = new Utility();
    const viewSourceComponentConfig = CQMasterDataStore.GridObject.gridComponentConfigView;
    const [filterByRecordTypeValue, filterByRecordType]: any = useState(viewSourceComponentConfig.filterByRecordTypeValue);
    const recordTypes = [...TemplateSFObjectStore.objectFields.recordTypeInfos];
    let itemIndex: any;
    recordTypes.forEach((currentRecord: any, index: number) => {
        let limitedRecordType = { ...currentRecord };
        if (limitedRecordType.name === 'Master') {
            itemIndex = index;
        }
    });
    let filteredRecordTypes: any = [];
    if (itemIndex > 0) {
        filteredRecordTypes = [...recordTypes];
        filteredRecordTypes.splice(itemIndex, 1);
    } else {
        filteredRecordTypes = [];
    }
    React.useEffect(() => {
        if (Object.keys(viewSourceComponentConfig).length !== 0) {
            const templateInfo = CQMasterDataStore.OutputConfig.getStoreData(props.selectedTemplateName);
            const underScoreRegex = new RegExp(`_`, 'g');
            const prefix = templateInfo.prefix;
            let childApiName = templateInfo.objectApiName;
            const childObject = TemplateSFObjectStore.sfObjects.filter((sfObject: any) => {
                return sfObject.name === childApiName;
            });
            let childObjectApiName: string = (childObject.length && childObject[0].name) as string;
            if (childObjectApiName && childObjectApiName.includes('__c')) {
                childObjectApiName = childObjectApiName.replace('__c', '');
            }
            childObjectApiName = util.toPascalCase(childObjectApiName);

            let isCustomSuffix = false;
            if (viewSourceComponentConfig.suffix && viewSourceComponentConfig.suffix.length > 3 && viewSourceComponentConfig.suffix.slice(0, 3) === 'For') {
                isCustomSuffix = viewSourceComponentConfig.suffix ?
                    filteredRecordTypes.some((recordType: any) => recordType.developerName.replace(underScoreRegex, '') === viewSourceComponentConfig.suffix.slice(3, viewSourceComponentConfig.suffix.length))
                    :
                    true;
            } else {
                isCustomSuffix = true;
            }
            isCustomSuffix = (filterByRecordTypeValue && viewSourceComponentConfig.filterByRecordTypeValue)
                ? (viewSourceComponentConfig.filterByRecordTypeValue !== filterByRecordTypeValue) : isCustomSuffix;

            if (filterByRecordTypeValue && filterByRecordTypeValue === 'Please select') {
                const compName = `cqui${prefix}${childObjectApiName}Grid`;
                props.updateViewSourceComponentConfig('filterByRecordTypeValue', '', compName, ' ');
                // props.updateViewSourceComponentConfig('suffix', recordType);
                templateConfigCtrl.updateFieldValue('limitToRecordType', '', props.selectedTemplateName);
            } else if (filterByRecordTypeValue
                && filterByRecordTypeValue !== 'Please select'
                && isCustomSuffix) {
                let recordType = filterByRecordTypeValue;

                if (recordType.includes('_')) {
                    recordType = recordType.replace(underScoreRegex, '');
                }
                const compName = `cqui${prefix}${childObjectApiName}${recordType}Grid`;
                props.updateViewSourceComponentConfig('filterByRecordTypeValue', filterByRecordTypeValue, compName, `For${recordType}`);
                // props.updateViewSourceComponentConfig('suffix', recordType);
                templateConfigCtrl.updateFieldValue('limitToRecordType', filterByRecordTypeValue, props.selectedTemplateName);
            }
            else {
                const compName = viewSourceComponentConfig.suffix ?
                    `cqui${prefix}${childObjectApiName}${viewSourceComponentConfig.suffix}Grid`
                    : `cqui${prefix}${childObjectApiName}Grid`;
                let recordType = filterByRecordTypeValue ? filterByRecordTypeValue : '';
                if (recordType.includes('_')) {
                    recordType = recordType.replace(underScoreRegex, '');
                }
                // const viewSourceConfig = {...CQMasterDataStore.GridObject.gridComponentConfigView};
                // viewSourceConfig.componentName = compName;
                // viewSourceConfig.filterByRecordTypeValue = filterByRecordTypeValue;
                // viewSourceConfig.suffix = filterByRecordTypeValue;
                // 
                // props.updateViewSource(viewSourceConfig);
                props.updateViewSourceComponentConfig('filterByRecordTypeValue', filterByRecordTypeValue, compName, (viewSourceComponentConfig.suffix !== undefined) ? viewSourceComponentConfig.suffix : recordType);
                // props.updateViewSourceComponentConfig('suffix', filterByRecordTypeValue);
                templateConfigCtrl.updateFieldValue('limitToRecordType', filterByRecordTypeValue, props.selectedTemplateName);
            }
        }
    }, [filterByRecordTypeValue]);
    return (
        <div className="slds-form-element">
            <label className="slds-form-element__label">{props.fieldInfo.name}</label>
            <div className="slds-form-element__control">
                <div className="slds-select_container">
                    <select className="slds-select" onChange={(e: any) => filterByRecordType(e.target.value)} value={viewSourceComponentConfig.filterByRecordTypeValue}>
                        <option value="Please select">Please select</option>
                        {filteredRecordTypes.length > 0 ? filteredRecordTypes.map((fieldValue: any) => {
                            return (<option key={fieldValue.developerName} value={fieldValue.developerName}>{fieldValue.name}</option>);
                        }) : <option value=''>No Data</option>};
                    </select>
                </div>
            </div>
        </div>
    );
}

export const GridComponentFilterByRecordType = observer(GridFilterByRecordType);